import { render, staticRenderFns } from "./MessageTags.vue?vue&type=template&id=2353f1f2"
import script from "./MessageTags.vue?vue&type=script&lang=js"
export * from "./MessageTags.vue?vue&type=script&lang=js"
import style0 from "./MessageTags.vue?vue&type=style&index=0&id=2353f1f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports